"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_REJECTED_TASKS = exports.USER = exports.USER_TASKS_BY_STATUS = exports.CONFIG = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.CONFIG = (type) => graphql_tag_1.default `
  ${type} Config($id: String!) {
    config(id: $id) {
      id
      maxAllocatedTasks
    }
  }
`;
exports.USER_TASKS_BY_STATUS = (type) => graphql_tag_1.default `
  ${type} Tasks($statuses: [Int]!, $userId: ID!, $first: Int!, $skip: Int!) {
    tasks(where: {
      statusInt_in: $statuses,
      assignee: $userId
    }, first: $first, skip: $skip) {
      id
      endDate
      reallocationTime
      status
      assignee {
        id
      }
    }
  } 
`;
exports.USER = (type) => graphql_tag_1.default `
  ${type} User($id: String!) {
    user(id: $id) {
      id
      benefits
      available
    }
  }
`;
exports.USER_REJECTED_TASKS = (type) => graphql_tag_1.default `
  ${type} User($id: String!) {
    user(id: $id) {
      rejectedTasks {
        task {
          id
          endDate
          reallocationTime
          status
        }
      }
    }
  }
`;
//# sourceMappingURL=index.js.map